// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store'
import VueScrollTo from 'vue-scrollto'
import VueI18n from 'vue-i18n'
import messages from './i18n'

Vue.config.productionTip = false
Vue.use(VueScrollTo)
Vue.use(VueI18n)

axios.defaults.baseURL = process.env.API_URL || ''

const lang = navigator.language.split('-')

const i18n = new VueI18n({
	locale: lang[0], // set locale
	fallbackLocale: 'en',
	messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {App},
	template: '<App/>',
	i18n
})



// WEBPACK FOOTER //
// ./src/main.js